import type { FeatureName } from "@lib/featureFlipper";

type FeatureOn = (featureName: FeatureName) => boolean;

/**
 * Whether landing-page surveys are available in this workspace.
 *
 * Landing-page surveys are a sub-feature of Landing Pages (`landing_pages`):
 * the surveys flipper only ever narrows that entitlement, never widens it. The
 * feature YAML declares `landing_pages` as a prerequisite, but prerequisites are
 * enforced at flipper-write time only -- `useFeatureOn` is a flat lookup with no
 * prerequisite resolution, so "surveys on, landing pages off" is a reachable
 * state that every LP-survey surface has to resolve for itself.
 *
 * @param featureOn Feature flipper lookup
 * @return True when both `landing_pages` and `landing_page_surveys` are enabled
 */
export const isLandingPageSurveysEnabled = (featureOn: FeatureOn): boolean => {
  return featureOn("landing_pages") && featureOn("landing_page_surveys");
};
